<template>
  <div class="cursor-pointer relative" :class="iconSize" @click="$emit('click', $event)">
    <base-icon :name="name" :size="size" :custom="custom"/>
  </div>
</template>

<script>
import icons from '@/components/icons/_iconLibrary'
export default {
  name: 'base-icon-clickable',
  props: {
    name: {
      type: String,
      required: true,
      validator: function (value) {
        return icons.includes(value)
      }
    },
    size: {
      type: String,
      default: 'md'
    },
    custom: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconSize: function () {
      return {
        'w-2 h-2': this.size === 'tiny',
        'w-3 h-3': this.size === 'xs',
        'w-4 h-4': this.size === 'xsm',
        'w-5 h-5': this.size === 'sm',
        'w-6 h-6': this.size === 'md',
        'w-8 h-8': this.size === 'lg'
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
